import "./index.scss";
import Nav from "../../../components/Nav";
import Button from "../../../components/Button";
import {useNavigate} from "react-router-dom";
import ReportAloneItem from "../../../components/ReportAloneItem";
import Loader from "../../../components/Loader";
import {useEffect, useState} from "react";
import {useGet} from "../../../api/request";
import {useSelector} from "react-redux";
import Modal from "../../../components/Modal";
import {useAlert} from "../../../components/AlertNotification";
import Stats from "../Stats";


const Main = () => {
    const navigate = useNavigate();
    const getU = useGet();
    const alertU = useAlert();

    const isReadyToWork = useSelector(state => state.work.isReadyToWork)
    const isPaused = useSelector(state => state.work.isPaused)
    const [isLoading, setIsLoading] = useState(false);
    const [modalStatus, setModalStatus] = useState({
        isActive: false,
        id: 0,
    });

    const [reports, setReports] = useState([]);
    const [yesterdayReports, setYesterdayReports] = useState([]);
    const [statusesList, setStatusesList] = useState([]);

    const getStatusName = (statusKey) => {
        const status = statusesList.find(s => s.key === statusKey);
        return status ? status.name : statusKey;
    };

    const getAllReportsInfo = () => {
        setIsLoading(true)

        getU('stats')
            .then((response) =>{
                if (response.status === 'success'){
                    setReports(response.data.applications || [])
                    setYesterdayReports(response.data.yesterdayApplications || [])
                }
            })
            .catch((e) =>{
                alertU({
                    status: 'error',
                    title: 'Получение заявок',
                    message: e.response.data.message
                });
            })
            .finally(() =>{
                setIsLoading(false)

            })
      
    }
    const onMoveCreateReport = () => {
        navigate("/app/main/create-report")
    }



    useEffect(() => {
        getU("applications/statuses")
            .then((response) => {
                if (response.status === "success") {
                    setStatusesList(response.data.statuses);
                }
            })
            .catch(() => {});
    }, []);

    useEffect(()=>{
        getAllReportsInfo()
    },[])


    return (
        <>
            <div className="main">
                <Nav/>
                <Stats setIsLoading={setIsLoading} />
                <div className="main__button">
                    <Button text={"Создать заявку"} onClick={onMoveCreateReport} isDisabled={isReadyToWork && !isPaused}/>
                </div>
                {
                    reports.length !== 0 &&
                    <div className="main__last-reports-block">
                        <div className="main__last-reports-block-title">
                            Последние заявки
                        </div>
                        <div className="main__last-reports-block-list">
                            {
                                reports?.map((item) =>
                                    <ReportAloneItem
                                        id={item.id}
                                        status={item.status || ''}
                                        date={item.creationDate}
                                        setModalActive={setModalStatus}
                                        modalStatus={modalStatus}
                                        allowChangeStatus={item.status !== 'payment'}
                                        statusesList={statusesList}
                                        link={item.link}
                                        email={item.email}
                                        phone={item.phone}
                                        anotherContact={item.anotherContact}
                                        message={item.message}
                                        cost={item.cost}
                                    />
                                )
                            }
                        </div>
                    </div>

                }
                {
                    yesterdayReports.length !== 0 &&
                    <div className="main__last-reports-block">
                        <div className="main__last-reports-block-title">
                            Вчерашние заявки
                        </div>
                        <div className="main__last-reports-block-list">
                            {
                                yesterdayReports?.map((item) =>
                                    <ReportAloneItem
                                        id={item.id}
                                        status={item.status || ''}
                                        date={item.creationDate}
                                        setModalActive={setModalStatus}
                                        modalStatus={modalStatus}
                                        allowChangeStatus={item.status !== 'payment'}
                                        statusesList={statusesList}
                                        link={item.link}
                                        email={item.email}
                                        phone={item.phone}
                                        anotherContact={item.anotherContact}
                                        message={item.message}
                                        cost={item.cost}
                                    />
                                )
                            }
                        </div>
                    </div>

                }
                {
                    reports.length === 0 && yesterdayReports.length === 0 && !isLoading &&
                    <div className="main__empty-state">
                        Нет данных
                    </div>
                }
            </div>
            {modalStatus.id !== 0 &&
            <Modal modalStatus={modalStatus} setModalStatus={setModalStatus} onStatusUpdated={getAllReportsInfo}/>
            }
            {isLoading && (
                <Loader/>
            )}
        </>
    );
};

export default Main;
